// extracted by mini-css-extract-plugin
module.exports = {"search":"Search_search__2yXGX","loader":"Search_loader__3a-u2","spin":"Search_spin__1mg2f","none":"Search_none__L8s7X"};